import { getHelpCenterAri } from '@helpcenter/meta';

const EMPTY_VALUES_LIST = ['undefined', 'null'];

export const hasValidHelpCenterARI = (): boolean => {
    const helpCenterAri = getHelpCenterAri();
    return Boolean(helpCenterAri) && !EMPTY_VALUES_LIST.includes(helpCenterAri);
};
